/** Stable logical identities for this capability's owned fixed UDO templates. */
export enum PaymentGatewayWorkspaceCapabilityUdoTemplateKey {
    paymentSession = "169f46a1-96c5-417e-bdaa-33b087ff2180",
    webhookEvent = "38b7ddb1-c7d9-4733-885b-65e7bcabe97c",
}
